// Part numbers arrive from three places: typed by the customer, read off a
// barcode, or picked from the cabinet stock list. Stock matching on the server
// (decrement_cabinet_item) compares strings exactly, so everything is folded to
// the same shape before it is compared or submitted.

const isControlChar = (ch: string): boolean => {
  const code = ch.charCodeAt(0);
  return code < 32 || code === 127;
};

export const normalizePartNumber = (raw: string): string =>
  Array.from(raw, (ch) => (isControlChar(ch) ? ' ' : ch))
    .join('')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();

// Retail barcodes (UPC-A, EAN-13, GTIN-14) encode a product code, not an OEM
// part number. Callers use this to warn the customer to double-check the value.
export const looksLikeGtin = (code: string): boolean => /^\d{12,14}$/.test(code.trim());
